/*
 * PathBackdrop — subtle "planning zone" backdrop for Career Path & subsections.
 *
 * Requirements (from spec):
 *   - Creative, calm, warm — signals a "planning zone"
 *   - Consistent with dark/gold palette
 *   - Very subtle animation: full cycle ~20s, no pulsing, no flashing
 *   - Respects prefers-reduced-motion
 *   - CSS-only, GPU-friendly (transform + opacity only)
 *   - Modular — swap or remove without touching pages
 */
export default function PathBackdrop() {
  return (
    <>
      <style>{`
        @keyframes path-drift {
          0%   { transform: translate3d(-2%, -1%, 0) scale(1);   opacity: 0.55; }
          50%  { transform: translate3d( 2%,  1%, 0) scale(1.03); opacity: 0.70; }
          100% { transform: translate3d(-2%, -1%, 0) scale(1);   opacity: 0.55; }
        }
        .path-drift  { animation: path-drift 22s ease-in-out infinite; }
        .path-drift-2 { animation: path-drift 28s ease-in-out infinite reverse; }
        @media (prefers-reduced-motion: reduce) {
          .path-drift, .path-drift-2 { animation: none !important; }
        }
      `}</style>
      <div
        className="pointer-events-none fixed inset-0 overflow-hidden -z-10"
        data-testid="path-backdrop"
        aria-hidden="true"
      >
        {/* warm amber pool near the top-center — signals focus + direction */}
        <div
          className="absolute -top-32 left-1/2 -translate-x-1/2 w-[860px] h-[860px] rounded-full path-drift"
          style={{
            background:
              "radial-gradient(circle, rgba(255,190,110,0.14) 0%, rgba(255,190,110,0.06) 35%, transparent 65%)",
            filter: "blur(4px)",
            willChange: "transform, opacity",
          }}
        />
        {/* deeper cool pool bottom-right — depth, quiet counterweight */}
        <div
          className="absolute -bottom-40 -right-24 w-[560px] h-[560px] rounded-full path-drift-2"
          style={{
            background:
              "radial-gradient(circle, rgba(120,150,200,0.10) 0%, transparent 65%)",
            filter: "blur(4px)",
            willChange: "transform, opacity",
          }}
        />
        {/* very faint left glow — asymmetry, keeps balance interesting */}
        <div
          className="absolute top-1/3 -left-24 w-[380px] h-[380px] rounded-full path-drift-2"
          style={{
            background:
              "radial-gradient(circle, rgba(255,210,150,0.06) 0%, transparent 60%)",
            filter: "blur(2px)",
            willChange: "transform, opacity",
          }}
        />
        {/* subtle grain overlay — premium theatrical feel */}
        <div
          className="absolute inset-0 opacity-[0.035] mix-blend-overlay"
          style={{
            backgroundImage:
              "radial-gradient(rgba(255,220,180,0.6) 1px, transparent 1px)",
            backgroundSize: "3px 3px",
          }}
        />
      </div>
    </>
  );
}
